import bg_factoring from 'assets/svg/factoring/bg-factoring-complete.svg';
import IconEllipse from 'assets/svg/factoring/ellipse.inline.svg';
import IconDollar from 'assets/svg/icons/dollar.inline.svg';
import IconFile from 'assets/svg/icons/file.inline.svg';
import ButtonLink from 'components/Molecules/ButtonLink';
import SEO from 'components/SEO';
import { routes } from 'constants/routes';
import { Link } from 'gatsby';
import React from 'react';
import { css } from 'twin.macro';

const bgFactoring = css`
	height: 42vw;
	position: relative;
	background-image: url(${bg_factoring});
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain;
`;

export default function factoringComplete() {
	return (
		<div>
			<SEO
				title='Faktoring pełny co to? Jak i kiedy go stosować'
				keywords='faktoring pełny, definicja, faktoring mieszany, faktoring bez regresu, faktoring bez ryzyka, faktoring ubezpieczony, cena faktoringu, ubezpieczenie należności'
				description='Dowiedź się co to jest faktoring pełny, faktoring mieszany oraz jakie są jego wady i zalety i jak go stosować w transakcjach krajowych i zagranicznych.'
				contentType='article'
			/>

			<div css={bgFactoring} className='flex flex-col items-center justify-between pt-30'>
				<IconEllipse width='6.5rem' height='6.5rem' />
			</div>

			<p className='text-center text-20 font-bold mb-30'>Faktoring pełny</p>

			<div className='px-20 pt-20'>
				<p className='text-16 mb-10'>Faktoring pełny - definicja</p>
				<p>
					Faktoring pełny inaczej bez regresu to konstrukcja umowna w której jedynym dłużnikiem Faktora na skutek zawarcia takiej umowy jest kontrahent Faktoranta.
					Przedmiotem takiej transakcji faktoringowej mogą być wierzytelności Faktoranta wynikające z różnych dokumentów np. faktur, umów, porozumień czy uznania długu.
					W takim przypadku Faktor najczęściej dodatkowo zabezpiecza swojego ryzyka specjalną polisą ubezpieczenia należności w wyspecjalizowanym towarzystwie ubezpieczeń. Nie należy przy tym mylić tutaj faktoringu pełnego i niepełnego zabezpieczonego cesją praw z polisy ubezpieczenia należności. W obu przypadkach inny podmiot jest ubezpieczającym.
					Funkcja finansowa faktoringu pełnego polega na zabezpieczeniu Twojej firmy przed niewypłacalnością Twoich odbiorców oraz na skróceniu do minimum terminu płatności (inaczej refinansowaniu), dzięki czemu środki w Twojej firmie pojawiają się natychmiast po wystawieniu faktury, a Ty możesz nimi rozporządzać według potrzeb.
					Faktoring pełny jest zazwyczaj droższą usługą, głównie w związku z dodatkowym kosztem ryzyka kredytowego jakie Faktor przyjmuje w tym wypadku na siebie.
				</p>

				<p className='text-16 mb-10 mt-40'>Faktoring mieszany</p>
				<p>
					Faktoring mieszany stanowi hybrydę posiadającą cechy faktoringu pełnego i
					&nbsp;<Link to={routes.FACTORING_INCOMPLETE} className='link-in-text'>niepełnego</Link>.
					Spotykany głównie w przypadku dużych struktur finansowych, gdzie możliwe jest ustalenie indywidualnego parytetu ryzyka kredytowego pomiędzy faktorantem oraz firmą faktoringową. Umowa faktoringu mieszanego zawiera zatem postanowienia charakterystyczne dla faktoringu pełnego i niepełnego.
				</p>

				<p className='text-16 mb-10 mt-40'>Zalety faktoringu pełnego</p>
				<p>
					Faktoring pełny zaliczany jest do nowoczesnych i innowacyjnych sposobów finansowania bieżącej działalności przedsiębiorstw.
					Funkcja finansowa faktoringu pełnego polega przede wszystkim na skróceniu do minimum terminu płatności (inaczej refinansowaniu) dzięki czemu środki w Twojej firmie pojawiają się natychmiast po wystawieniu faktury, ale - co ważne - dodatkowo zabezpiecza Twoją firmę przed niewypłacalnością Twoich odbiorców.
					Utrzymanie w firmie płynności jest szczególnie ważne ze względu na:
				</p>

				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Utrzymanie zdolności pokrycia terminowych, ale także przede wszystkim niespodziewanych wydatków.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Zmniejszenie presji kontrahentów na ciągłe wydłużanie terminów płatności.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>Poprawa pozycji konkurencyjnej wobec kontrahentów (odbiorców) przy negocjowaniu cen oraz warunków umowy.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p>Posiadanie rezerwy płynności, która umożliwi wykorzystanie nadarzających się okazji biznesowych (np. zakupu surowców lub towarów  z dużym rabatem za gotówkę czy też zakup innej firmy).</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>5</div>
					<p>Możliwość utrzymania firmy nawet w przypadku wypowiedzenia kredytu bankowego.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>6</div>
					<p>Zróżnicowanie źródeł finansowania firmy.</p>
				</div>

				<p>Dodatkowa funkcja zabezpieczająca przed niewypłacalnością Twoich odbiorców ułatwi Ci:</p>
				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Podjęcie decyzji o rozpoczęcie współpracy z nieznanymi i niesprawdzonymi krajowymi odbiorcami.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Uwolnienie zasoby zaangażowane do stałego monitoringu spłat i Twoich należności.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>Rozpoczęcie współpracy z klientami z zagranicy.</p>
				</div>

				<p className='mt-20'>
					Podsumowując, <Link to={routes.FACTORING} className='link-in-text'>faktoring</Link> pełny to jeden z najlepszych i najważniejszych instrumentów
					poprawy płynności finansowej przedsiębiorstw i powinien być dostępny na stałe w arsenale każdej firmy działającej w obszarze B2B.
				</p>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Jest zdecydowanie najbezpieczniejszym instrumentem dłużnym porównując go do kredytu czy też pożyczki.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Powinien być wykorzystywany w pierwszej kolejności przed kredytem i pożyczką. odróżnieniu od nich faktoring może stanowić istotną zaporę przed ryzykiem wpadnięcia w spiralę zadłużenia. </p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Jest również świetnym testem na rentowność Twojego biznesu.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Często, jego rola jako jedynego źródła finansowania działalności jest niedoceniana przez przedsiębiorców, głównie ze względu na pozornie skomplikowany charakter takich transakcji.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Nie tak dawno zarezerwowany wyłącznie dla dużych firm i tylko w wyspecjalizowanych bankach.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet' />
					<p>Dzisiaj dostępny dla każdego startupu lub firmy rodzinnej.</p>
				</div>

				<p className='text-16 mb-10 mt-40'>Faktoring krajowy</p>
				<p>Ze względu na kryterium geograficzne wyróżniamy faktoring pełny krajowy i eksportowy. Główna różnica sprowadza się tutaj do dwóch rzeczy. W przypadku faktoringu krajowego Twoi odbiorcy działają w Polsce, a Ty wystawiasz typową fakturę krajową w złotówkach (PLN). Jeżeli jednak zdarzy się sytuacja , że Twój odbiorca chce się rozliczyć w walucie obcej, to sam ten fakt nie przesądza o tym, że jest to faktoring zagraniczny. Jest to nadal faktoringiem krajowym, ale z ryzykiem walutowym. Ważne jest przy tym, aby pamiętać jego zabezpieczeniu, o ile wolumen transakcji na to pozwala.</p>

				<p className='text-16 mb-10 mt-40'>Faktoring zagraniczny</p>
				<p>
					W przypadku faktoringu pełnego zagranicznego możemy wyróżnić faktoring z dostawą wewnątrzwspólnotową oraz faktoring eksportowy. W przypadku dostaw wewnątrzwspólnotowych Twoi odbiorcy pochodzą z terenu Unii Europejskiej, a walutą rozliczeniową takich transakcji jest zazwyczaj PLN lub EUR.
					W przypadku faktoringu eksportowego dostarczasz towary lub świadczysz usługi dla firm spoza Unii Europejskiej. W takim przypadku walutą rozliczeniową może być niemal każda waluta danego kraju, np. GBP, USD, RUB.
					Ważnym aspektem faktoringu zagranicznego jest również  ryzyko kursowe, które wynika ze zmiany kursów walut powiązanych z PLN.
					W ostatnim czasie doświadczamy dużych zmian na kursie złotego (PLN), co w skrajnym przypadku może nie tylko „zjeść” całą Twoją marżę, ale także wygenerować pokaźną stratę na takiej transakcji.
					Pamiętaj, choć jest to faktoring pełny to firma faktoringowa może nie przejąć na siebie ryzyka kursowego. Przejęcie takiego ryzyka zwykle jest traktowane i wyceniane jako odrębna usługa.
				</p>

				<div className='w-full flex flex-col items-center justify-center'>
					<p className='text-16 mb-10 mt-40'>Jak zacząć?</p>

					<p className='text-center'>Sprawdź indywidualną ofertę dla Ciebie. Możesz to zrobić klikając poniżej.</p>
					<ButtonLink to={routes.OFFERS} primary tw='mt-10 mb-20 bg-accent-3 my-15 mx-auto'>
						<IconDollar/><p>Sprawdź ofertę</p>
					</ButtonLink>

					<p>Następnie złóż wniosek.</p>
					<ButtonLink to={routes.CONCLUSIONS} primary tw='mt-10 mb-20 bg-accent-3 my-15 mx-auto'>
						<IconFile /><p>Złóż wniosek</p>
					</ButtonLink>
				</div>

				<div>
					<p className='contents font-bold'>Pamiętaj:</p> Przed przystąpieniem do wypełniania wniosku przygotuj dane finansowe (za ostatni rok kalendarzowy)
					oraz dane dotyczące zobowiązań Twojej firmy. Dodatkowo zastanów się, jakich odbiorców zgłosisz do wniosku o limit faktoringowy.
					Wykonaj kolejno kroki:
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>1</div>
					<p>Wybierz rodzaj faktoringu: krajowy lub zagraniczny (eksportowy) w walucie.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>2</div>
					<p>Podaj dane wszystkich zgłaszanych odbiorców ( NIP lub nazwę) oraz kwotę sublimitu na każdego z nich.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>3</div>
					<p>W ostatnim kroku podaj wszystkie zobowiązania jakie posiada Twoja firma.</p>
				</div>
				<div className='flex items-center mt-03'>
					<div className='bullet'>4</div>
					<p>Sprawdź wstępną decyzję kredytową i wyślij wniosek do analizy przez naszych doradców.</p>
				</div>

				<p className='my-20'>Przygotowanie wniosku zajmie Ci 2 do 5 minut. Decyzja na wniosku jest decyzją wstępną co oznacza, że przed wydaniem końcowej decyzji możemy poprosić Ciebie o dodatkowe dokumenty oraz informacje. </p>
			</div>
		</div>
	);
}
